import { api } from "../utils/api";

const JobseekerService = {
  register: async (data) => {
    try {
      const formData = new FormData();
      formData.append("fullName", data.fullName);
      formData.append("email", data.email);
      formData.append("phone", data.phone);
      formData.append("postcode", data.postcode);
      formData.append("job", data.job);
      formData.append("resume", data.resume[0]); // use the first file

      const response = await api.post("/api/jobseekers/register", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Upload error:", error);
    }
  },

  /*
   * {
    "name": "Saket Bisht",
    "avatar": "C:\\fakepath\\CpI8CDV-cP4-HD.jpg",
    "jobTitle": "Software Engineer",
    "location": "New Delhi",
    "postcode": "110070",
    "latitude": "40.71",
    "longitude": "-74.098",
    "city": "delhi",
    "country": "india",
    "email": "bishtsaket@gmail.com",
    "phone": "8130118552",
    "education": [
      {
        "degree": "MCA",
        "institution": "IMS",
        "year": "2008"
      }
    ],
    "workExperience": [
      {
        "position": "EXPer1",
        "company": "Whoppit",
        "duration": "2020-2023",
        "responsibilities": [
          "role",
          "res2"
        ]
      }
    ],
    "skills": [
      "skill1",
      "skill2"
    ],
    "cv": {},
    "job": "684bb15af06cae6f1b2e4fff"
  }
  */
  registerToJob: async (data) => {
    try {
      const formData = new FormData();

      // Handle each field appropriately
      for (const [key, value] of Object.entries(data)) {
        if (key === "avatar" || key === "cv") {
          // Handle file uploads
          if (value && value instanceof File) {
            formData.append(key, value);
          }
        } else if (
          key === "education" ||
          key === "workExperience" ||
          key === "skills"
        ) {
          // Handle arrays and objects by converting to JSON
          formData.append(key, JSON.stringify(value));
        } else if (typeof value === "object" && value !== null) {
          // Handle other objects
          formData.append(key, JSON.stringify(value));
        } else {
          // Handle primitive values (string, number, boolean)
          formData.append(key, value);
        }
      }

      const response = await api.post("/api/companies/contact/add", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Upload error:", error);
      throw error; // Re-throw to handle in component
    }
  },

  searchJobseeker: async (filters) => {
    try {
      const response = await api.post("/api/jobseekers/search", filters);
      return response.data.data;
    } catch (error) {
      return error?.response?.data ?? [];
    }
  },

  getPendingQuestion: async (jobseekerId, jobId) => {
    if (jobseekerId === "undefined" || jobId === "undefined") {
      return [];
    }
    try {
      const response = await api.get(
        `/api/jobseekers/questionnaire/pending/${jobseekerId}/${jobId}`,
      );
      return response.data ?? [];
    } catch (error) {
      return error?.response?.data ?? [];
    }
  },
};

export default JobseekerService;
